import React, { useState, useMemo, useEffect } from 'react';
import { useCollect, useIsInViewport } from 'hooks';
import { useFirstRender } from 'react-haiku';

import Show from 'components/Show';
import Button from 'components/Ui/Button';
import Progress from 'components/Misc/Progress';
import { Title } from 'components/Misc/Typography';

import Search from 'components/Messenger/Search';
import Contact from 'components/Messenger/Contacts/Contact';

import { useMessengerStore } from 'store/useMessengerStore';
import { identity, pickBy } from 'lodash';

const Users = () => {
	// Use messenger's store
	const [contacts, onAddContacts, updateView] = useMessengerStore(state => [
		state.contacts,
		state.onAddContacts,
		state.updateView
	]);

	// Store search parameters
	const [search, setSearch] = useState({
		name: '',
		role: '',
		page: 1
	});

	// Create request parameters
	const parameters = useMemo(() => pickBy({
		'name|surname:likeLower': `%${search.name}%`,
		'role:in': search.role,
		page: search.page
	}, identity), [search]);

	// Store collected conversations
	const [[results, progress], collect] = useCollect('contacts', parameters);

	// Handle search parameter change
	const onChange = (event) => {
		const { name, value } = event.target || event;
		setSearch(prev => ({
			...prev,
			[name]: value,
			page: 1
		}));
	};

	// Handle page change
	const onPage = () => {
		setSearch(prev => ({
			...prev,
			page: prev.page + 1
		}));
	};

	// Handle view change to contacts
	const onConversations = () => updateView('conversations');

	// Handle scroll in contact container
	const onScroll = (event) => {
		// Get element's properties
		const { scrollTop, scrollHeight, clientHeight } = event.target;

		// Check if scrolled to bottom
		const isBottom = scrollTop + clientHeight >= scrollHeight;

		// Check if all results are collectec
		const allCollected = results?.total === contacts?.length;
		
		// Update page on bottom reach
		if (isBottom && !progress && !allCollected) onPage();
	};

	// Collect conversations on mount
	useEffect(() => {
		(async () => await collect())();
	}, [collect]);

	// Initialize messenger's state
	useEffect(() => {
		if (results) onAddContacts(results.users, search.page === 1);
	}, [results, search]);

	return (
		<div className="flex flex-col h-full max-h-full">
			<div className="px-3 h-12 flex items-center space-x-3 bg-neutral-100 dark:bg-neutral-700 transition-colors">
				<Title
					title="Kontakti"
					className="flex-1"
				/>

				<Button
					small
					square
					icon="chat"
					onClick={onConversations}
				/>
			</div>

			{/* Contact search */}
			<Search search={search} onChange={onChange} />

			{/* Contact list */}
			<div onScroll={onScroll} className="p-1 flex-1 overflow-y-auto">
				{contacts?.map(user =>
					<Contact key={user.id} user={user} />
				)}

				{/* Show loading progress */}
				<Progress progress={progress} />
			</div>
		</div>
	);
};

export default Users;
